import { createFileRoute } from '@tanstack/react-router';
import { SendMoneyCalculatorPage } from '~/components/sections/SendMoneyCalculatorPage';
import { sendMoneyHero } from '~/content/sendMoneyHome';
import { pageHeadMeta } from '~/lib/seo';
import calculatorCss from '~/styles/calculator.css?inline';

export const Route = createFileRoute('/send-money-home')({
  head: () =>
    pageHeadMeta({
      title: 'Send money home at the best rates — nsave',
      description:
        "Convert and send money internationally for just $1 with nsave's currency calculator. Get the best exchange rates for USD to BDT, EGP, PKR, TRY, and more.",
      path: '/send-money-home',
      // Inlined (not a linked stylesheet) — calculator.css's descender-clipping
      // override only wins the cascade-layer race when inlined into <head>.
      inlineStyles: [calculatorCss],
    }),
  component: SendMoneyHomePage,
});

function SendMoneyHomePage() {
  return <SendMoneyCalculatorPage heroTitle={sendMoneyHero.title} initialTarget="EGP" />;
}
